module.exports = __webpack_public_path__ + "static/media/2.6f5b88c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Hero/2.jpg
// module id = 251
// module chunks = 0